import { SVGProps } from "react";

export function ClipboardIcon({
  size = 63,
  color = "currentColor",
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 63 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...(props as any)}
    >
      <path
        d="M27.6249 36.1667H44.4166M18.5833 36.1667H19.8749M18.5833 27.125H19.8749M18.5833 45.2083H19.8749M27.6249 27.125H44.4166M27.6249 45.2083H44.4166"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M21.1667 9.0415C21.1667 8.01379 21.575 7.02817 22.3017 6.30147C23.0284 5.57476 24.014 5.1665 25.0417 5.1665H37.9584C38.9861 5.1665 39.9717 5.57476 40.6985 6.30147C41.4252 7.02817 41.8334 8.01379 41.8334 9.0415V11.6248C41.8334 12.6526 41.4252 13.6382 40.6985 14.3649C39.9717 15.0916 38.9861 15.4998 37.9584 15.4998H25.0417C24.014 15.4998 23.0284 15.0916 22.3017 14.3649C21.575 13.6382 21.1667 12.6526 21.1667 11.6248V9.0415Z"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M54.75 41.3332C54.75 48.6415 54.75 52.2943 52.4792 54.565C50.2111 56.8332 46.5557 56.8332 39.25 56.8332H23.75C16.4443 56.8332 12.7889 56.8332 10.5207 54.565C8.25 52.2917 8.25 48.6415 8.25 41.3332V33.5832M41.8333 10.3384C47.4521 10.3694 50.4952 10.62 52.4792 12.604C54.75 14.8747 54.75 18.5275 54.75 25.8332V30.9999M21.1667 10.3384C15.5479 10.3694 12.5047 10.62 10.5207 12.604C8.53675 14.588 8.28617 17.6311 8.25517 23.2499"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
